import { Types } from '../actionTypes';


const initState = [];

const procDemand = (state = initState, action) => {
  switch (action.type) {
    case Types.PROC_ADD_DEMAND_ITEM:
      return [
        ...state,
        action.payload];

    case Types.PROC_UPD_DEMAND_ITEM:
      let filteredProcDemand = state.filter(item => item.ItemId !== action.payload.ItemId);
      filteredProcDemand = [...filteredProcDemand, action.payload]
      return [
        ...filteredProcDemand
      ];


    case Types.PROC_DEL_DEMAND_ITEM:
      let filtered_ProcDemand = state.filter(item => item.ItemId !== action.payload)
      return [

        ...filtered_ProcDemand
      ]


    default:
      return state;
  }
};

export default procDemand;
